(function($) {
    $.widget("ca.caPhone", {
        _create : function() {
            var self = this;
            var id = self.element.attr('id');
            self.element.find('.ca-text-field').on('keyup', function () {
                if ($(this).attr('phone_prev_value') != $(this).val()) {
                    if ($(this).val().length == $(this).attr('maxlength')) {
                        if ($(this).hasClass('first')) {
                            self.element.find('.ca-text-field.second').focus();
                        } else if ($(this).hasClass('second')) {
                            self.element.find('.ca-text-field.third').focus();
                        }
                    }
                }
                $(this).attr('phone_prev_value', $(this).val());
            });
        }
    });
})(jQuery);